/** Bottom Swiper  Column [Start] **/
if($('.module-xboxes').length ){
  hp.swipers = hp.swipers || {};
  var module_xboxes = 
  {
    initialized: false
  };

  var init = function(){
    var card_length = 0;
    var slidesToShow = $(".swiper-card").length < 5 ? $(".swiper-card").length : 4.2;
    console.log($(".swiper-card").length);
    var swiperPromoProps = {
      pagination: {
        type: 'bullets',
        clickable: true,
       
      },
      slidesPerView: slidesToShow, //(($(".swiper-card").length / 3) > 4 ? (($(".swiper-card").length / 3) + .15) : 4) 
      spaceBetween: 0,
      loop: true,
      loopAdditionalSlides: 1,
      watchOverflow:false,
      breakpoints: {
       
        767: {
          slidesPerView: 1.1,
          spaceBetween: 0
        },
        320: {
          slidesPerView: 1.15,
          spaceBetween: 0
        }
      }
    }

    var swiperPromoMethods = {
      onlyMobileSwipe: true,
      a11ySwiper: true,
      resizeHandler: true,
      customMethods: [{
        fnName: "nextSlide",
        method: function (sw) {
          var element = $(sw.$el.find(".promo-box-right-arrow"));
          element.before().on("click", function (e) {
            e.stopPropagation();
            sw.slideNext();
          })
        }
      }, {
        fnName: "clickOnPromoHead",
        method: function (sw) {
            sw.$el.find(".swiper-promo-pannel").on("click", function (e) {
              $(this).find(".homepage-anchor")[0].click();
            })
        }
      }],
      swiperEvents: [{
        eventName: "slideChangeTransitionStart",
        eventMethod: function (sw) {
          if ($(sw.$el).find(".swiper-slide-active .background-black").length > 0) {
            $($(sw.$el).find(".swiper-pagination-bullet").css("background", "#424242"));
            $($(sw.$el).find(".swiper-pagination-bullet-active").css("background", "#cccccc"));
          } else {
            $($(sw.$el).find(".swiper-pagination-bullet").css("background", ""));
          }
        }
      }, {
        eventName: "transitionStart",
        eventMethod: function () {
          $('#tooltip').remove();
        }
      }]
    }

    if($('.module-xboxes').length){
      module_xboxes.instances = hp.swiperInstance('.module-xboxes', swiperPromoProps, swiperPromoMethods);  
      module_xboxes.initialized = true;
    }
    /** Promo Swiper 4 Column [END] **/
    swiperCardAligner();
    arrowHider();
    
  }//END init
  module_xboxes.init = init;
  

  hp.swipers.module_xboxes = module_xboxes;
  
}

// START - Special method to help fix issues in promo colums when copy is too large to fit
function swiperCardAligner(){
  if(window.innerWidth > 767 && window.innerWidth < 1025 ){
      var $cont = $('.swiper-promotion-container .module-xboxes'),
              $contHSC = $cont.find('.homepage-subheading-container');
    $contHSC.css({'min-height':'auto'});

    $cont.each(function(i,x){
      var card_max_height = 0;
      $('.homepage-subheading-container .homepage-subheading-text').each(function(ii,xx){
          
          card_max_height = $(xx)[0].clientHeight > card_max_height ? $(xx)[0].clientHeight : card_max_height;
      });
        $(x).find('.homepage-subheading-container').height(card_max_height)
        $(x).find('.swiper-card').height("auto");
        maxHeight = 0;
        $(x).find('.swiper-card').each(function(ii,xx){
            maxHeight = $(xx).height() > maxHeight ? $(xx).height() : maxHeight;
        })
        $(x).find('.swiper-card').height(maxHeight)
    })
  }else if(window.innerWidth){
      var $cont = $('.swiper-promotion-container .module-xboxes');
      $cont.each(function(i,x){
          var card_max_height = 0;
          var logo_max_height = 0;
          $('.homepage-subheading-container .homepage-subheading-text').each(function(ii,xx){
              
              card_max_height = $(xx)[0].clientHeight > card_max_height ? $(xx)[0].clientHeight : card_max_height;
          });
            $(x).find('.homepage-subheading-container').height(card_max_height);
          
            $(".border-promo.no-border").each(function(ii,xx){
              logo_max_height = $(xx)[0].clientHeight > logo_max_height ? $(xx)[0].clientHeight : logo_max_height;
            });
            $(x).find(".border-promo.no-border").height(logo_max_height);
            $(x).find('.swiper-card').height("auto");
            maxHeight = 0;
            $(x).find('.swiper-card').each(function(ii,xx){
                maxHeight = $(xx).height() > maxHeight ? $(xx).height() : maxHeight;
            })
            $(x).find('.swiper-card').height(maxHeight)
        })
  }
}
// END - Special method to help fix issues in promo colums when copy is too large to fit

// START - To hide a Arrow on less than 5 slides
function arrowHider(){
  if(window.innerWidth > 767){
    if(($(".swiper-card").length )/ 3 < 5 ){
      $(".module-xboxes .swiper-slide.no-border.swiper-slide-duplicate-prev .promo-box-right-arrow").detach();
      $(".module-xboxes .swiper-slide.no-border.swiper-slide-duplicate-prev .homepage-subheading-container").css({opacity:1});
      $(".module-xboxes .swiper-slide.no-border.swiper-slide-duplicate-prev .border-promo.no-border").css({opacity:1});
    }else{
    console.log("00");
    }
  }
}

// END - To hide a Arrow on less than 5 slides


